import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';

import { BaseComponent } from '@core/components/base/base.component';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-announcement',
    templateUrl: './announcement.component.html',
    styleUrls: ['./announcement.component.scss'],
    standalone: true,
    imports: [MatDialogModule, MatIconModule]
})
export class AnnouncementComponent extends BaseComponent {
    imageUrl = '';

    constructor(
        @Inject(MAT_DIALOG_DATA) data: any,
        public dialogRef: MatDialogRef<AnnouncementComponent>
    ) {
        super();

        this.imageUrl = data;
    }

    close() {
        this.dialogRef.close('close');
    }
}
